export interface ICatalogoGenerico {
  id?: string | null;
  clave?: string | null;
  descripcion?: string | null;
}

export class CatalogoGenerico implements ICatalogoGenerico {
  constructor(public id?: string | null, public clave?: string | null, public descripcion?: string | null) {}

  static fromObject(data: ICatalogoGenerico): CatalogoGenerico {
    const catalogoGenerico = new CatalogoGenerico();
    for (const [key, value] of Object.entries(data)) {
      catalogoGenerico[key] = value;
    }
    return catalogoGenerico;
  }
}
